// extracted by css-extract-rspack-plugin
export default {"label":"ldbPaG","percent":"CQ43X4","row":"Gajf92","bold":"xNzTC2","highlight":"DO3FFw","cross":"wTTqKk","value":"gdptAi","chart":"jmYm_D","pie":"Eo1MUn","line":"Ix5g14"};